module.exports = __webpack_public_path__ + "static/img/coding_Icon.78097e3.svg";